import Vue from 'vue';
import Zeiterfassung_mitarbeiterService from './zeiterfassung_mitarbeiter.service';
import * as _ from 'lodash';

const getDefaultItem = () => ({
    id: null,
    von: new Date(),
    bis: new Date(),
    user: null,
    beschreibung: '',
});

const getDefaultState = () => ({
    item: getDefaultItem(),
    list: [],
    currentPage: 0,
    totalPages: 1,
    timemode: false,
});

const zeiterfassung_mitarbeiter = {
    namespaced: true,

    state: Object.assign({}, getDefaultState()),

    mutations: {
        update(state, data) {
            Vue.set(state, 'item', data);
        },
        updateList(state, data) {
            Vue.set(state, 'list', data);
        },
        clearItem(state) {
            Vue.set(state, 'item', getDefaultState().item);
        },
        clear(state) {
            Object.assign(state, getDefaultState());
        },
        updateCurrentPage(state, data) {
            Vue.set(state, 'currentPage', data);
        },
        updateTotalPages(state, data) {
            Vue.set(state, 'totalPages', data);
        },
        updateTimeMode(state, data) {
            Vue.set(state, 'timemode', data);
        },
    },

    actions: {
        async clearItem(context) {
            context.commit('clearItem');
        },
        async clear(context) {
            context.commit('clear');
        },
        async create(context, client_data) {
            const { data } = await Zeiterfassung_mitarbeiterService.create(client_data);
            context.commit('update', data);
            return data;
        },
        async update(context, client_data) {
            const { data } = await Zeiterfassung_mitarbeiterService.update(client_data.id, client_data);
            context.commit('update', data);
            return data;
        },
        async get(context, id) {
            const { data } = await Zeiterfassung_mitarbeiterService.get(id);
            context.commit('update', data);
            context.commit('updateTimeMode', true);
            return data;
        },
        async updateTimeMode(context, mode) {
            context.commit('updateTimeMode', mode);
            return mode;
        },
        async duplicate(context, id) {
            const { data } = await Zeiterfassung_mitarbeiterService.get(id);
            data.id = null;
            context.commit('update', data);
            context.commit('updateTimeMode', true);
            return data;
        },
        async query(context, params) {
            const { headers, data } = await Zeiterfassung_mitarbeiterService.query(params);
            let currPage = params && params.params && params.params.page ? params.params.page : 0;
            context.commit('updateCurrentPage', currPage);

            let size = params && params.params && params.params.size ? params.params.size : 20;
            let totalCount = headers['x-total-count'];
            let totalPages = 1;

            if (_.toNumber(totalCount) > 0 && _.toNumber(size) > 0) {
                totalPages = _.toNumber(totalCount) / _.toNumber(size);
            }

            context.commit('updateTotalPages', _.ceil(totalPages));

            context.commit('updateList', data);
            return data;
        },
        async loadMore(context, params) {
            const { data } = await Zeiterfassung_mitarbeiterService.query(params);
            const items = context.getters.list;
            items.push(...data);
            context.commit('updateList', items);
            return data;
        },
        async delete(context, slug) {
            await Zeiterfassung_mitarbeiterService.delete(slug);
        },
    },

    getters: {
        data(state) {
            return state.item;
        },
        list(state) {
            return state.list;
        },
        currentPage(state) {
            return state.currentPage;
        },
        totalPages(state) {
            return state.totalPages;
        },
        timemode(state) {
            return state.timemode;
        },
    },
};

export default zeiterfassung_mitarbeiter;
